import { TableHeader } from '@/components/tables/table-header';
import { useProductAvailibilityColumns } from '@/features/list-views/columns/use-product-availibility-columns';
import { DataTable } from '@/features/list-views/components/data-table';
import { api } from '@/utils/api';
import { getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { useMemo } from 'react';

type Props = {
    erpProductId: string;
};

export const InventoryDetailsAvailability = ({ erpProductId }: Props) => {
    const availibilityColumns = useProductAvailibilityColumns();

    const { data: availibilityRawData, isLoading: isLoadingAvailibility } =
        api.platoUser.grid.getManyStorageStockLevels.get.useQuery({
            productVariantId: erpProductId,
        });

    const availibilityCount = availibilityRawData ? availibilityRawData.length : 0;

    const availibilityData = useMemo(
        () => (availibilityRawData ? availibilityRawData : []),
        [availibilityRawData],
    );

    const availibilityTable = useReactTable({
        data: availibilityData,
        columns: availibilityColumns,
        getCoreRowModel: getCoreRowModel(),
    });

    return (
        <>
            <DataTable
                isLoading={isLoadingAvailibility}
                table={availibilityTable}
                columns={availibilityColumns}
            />
            <TableHeader count={availibilityCount} isLoadingCount={isLoadingAvailibility} />
        </>
    );
};
